import { ScmInstance } from "@/instance/axios";
import {
  AuthSignupPost201ResponseEquipmentPurchaseOrderItem,
  AuthSignupPost201ResponseEquipmentPurchaseOrderItemStatusEnum,
} from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import dayjs from "dayjs";

export type PurchaseOrderItemsOption = {
  value: string;
  label: string;
  availableStockPlanQuantity?: string;
};

const getAutoCompleteKeyword = (
  keyword: string,
  itemCodes: any,
  direction: string,
  status: boolean,
) =>
  ScmInstance.purchaseOrderItemsFindPost({
    query: JSON.stringify({
      $and: [
        ...(direction ? [{ direction: { $eq: direction } }] : []),
        ...(itemCodes ? [{ itemCode: { $eq: itemCodes } }] : []),
        ...(status
          ? [
              {
                status: {
                  $in: [
                    AuthSignupPost201ResponseEquipmentPurchaseOrderItemStatusEnum.DRAFT,
                    AuthSignupPost201ResponseEquipmentPurchaseOrderItemStatusEnum.PARTIAL_DELIVERED,
                  ],
                },
              },
            ]
          : []),
      ],
    }),
    populate: ["purchaseOrderCode", "purchaseOrder", "quantities", "partner"],
  }).then((res: AxiosResponse<AuthSignupPost201ResponseEquipmentPurchaseOrderItem[]>) => res.data);

export const usePurchaseOrderItemsAutoComplete = (
  focus = false,
  itemCodes: any,
  direction: string,
  status: boolean = false,
  keyword = "",
  options?: {
    onSuccess: (data: PurchaseOrderItemsOption[]) => void;
  },
) => {
  return useQuery(
    ["purchaseOrderItems-get-autocomplete", keyword, itemCodes, direction, status],
    () => getAutoCompleteKeyword(keyword, itemCodes, direction, status),
    {
      // enabled: focus,
      select: (data: AuthSignupPost201ResponseEquipmentPurchaseOrderItem[]) =>
        data?.map((purchaseOrderItems) => {
          return {
            value: purchaseOrderItems.id?.toString() as string,
            label: `수주코드 : ${purchaseOrderItems.purchaseOrderCode ?? "-"} | 협력사명: ${purchaseOrderItems.partner?.name ?? "-"} | 수주수량 : ${purchaseOrderItems.quantity} | 납기일 : ${purchaseOrderItems.deliveryDeadline ? dayjs(purchaseOrderItems.deliveryDeadline).format("YYYY-MM-DD") : "-"} | 미납품수량 : ${purchaseOrderItems.remainingDeliveryQuantity ?? 0} | 재고계획가능수량 : ${purchaseOrderItems.availableStockPlanQuantity ?? 0}`,
            availableStockPlanQuantity: purchaseOrderItems.availableStockPlanQuantity ?? "0",
            group: purchaseOrderItems.partner?.name ?? "-",
          };
        }) ?? [],
      onSuccess: options?.onSuccess,
    },
  );
};

const getPurchaseOrderItemsByCode = (code: string | null) =>
  ScmInstance.purchaseOrderItemsFindPost({
    ...(code && { search: code, populate: ["partner"] }),
    // searchFields: ["code"],
  }).then((res: AxiosResponse<AuthSignupPost201ResponseEquipmentPurchaseOrderItem[]>) => res.data);

export const usePurchaseOrderItemsCode = (
  enabled: boolean,
  code: string | null,
  options?: {
    onSuccess: (data?: PurchaseOrderItemsOption[]) => void;
  },
) => {
  return useQuery(["purchaseOrderItems-get-code", code], () => getPurchaseOrderItemsByCode(code), {
    enabled: enabled ?? false,
    select: (data: AuthSignupPost201ResponseEquipmentPurchaseOrderItem[]) =>
      data?.map((purchaseOrderItems) => {
        return {
          value: purchaseOrderItems.id?.toString() as string,
          label: `아이디 : ${purchaseOrderItems.id}, 업체명: ${purchaseOrderItems.partner?.name ?? "-"}, 수량 : ${purchaseOrderItems.quantity}, 접수일 : ${purchaseOrderItems.orderDate ? dayjs(purchaseOrderItems.orderDate).format("YYYY-MM-DD") : "-"}, 납기일 : ${purchaseOrderItems.deliveryDeadline ? dayjs(purchaseOrderItems.deliveryDeadline).format("YYYY-MM-DD") : "-"}`,
          group: purchaseOrderItems.partner?.name ?? "-",
        };
      }) ?? [],
    onSuccess: options?.onSuccess,
  });
};
